import { RoutesResRoutes } from '@conf/routes.config';

/**
 * 言語情報選択肢リスト
 */
export type AgreementLangItem = {
  code: string;
  disp: string;
};

/**
 * 遷移元画面定義
 * @param PLAN_LIST プランリスト
 * @param ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL 往復空席照会結果(国際)
 * @param ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC 往復空席照会結果(国内)
 * @param COMPLEX_FLIGHT_AVAILABILITY 複雑空席照会
 * @param PAYMENT_INPUT 支払情報入力
 */
export const AGREEMENT_PREVIOUS_PAGE = {
  PLAN_LIST: 'R01P042',
  ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL: 'R01P030',
  ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC: 'R01P031',
  COMPLEX_FLIGHT_AVAILABILITY: 'R01P033',
  PAYMENT_INPUT: 'R01P080',
};

export const AGREEMENT_PREVIOUS_PAGE_MAP = new Map([
  [AGREEMENT_PREVIOUS_PAGE.PLAN_LIST, RoutesResRoutes.PLAN_LIST],
  [
    AGREEMENT_PREVIOUS_PAGE.ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL,
    RoutesResRoutes.ROUNDTRIP_FLIGHT_AVAILABILITY_INTERNATIONAL,
  ],
  [
    AGREEMENT_PREVIOUS_PAGE.ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC,
    RoutesResRoutes.ROUNDTRIP_FLIGHT_AVAILABILITY_DOMESTIC,
  ],
  [AGREEMENT_PREVIOUS_PAGE.COMPLEX_FLIGHT_AVAILABILITY, RoutesResRoutes.COMPLEX_FLIGHT_AVAILABILITY],
  [AGREEMENT_PREVIOUS_PAGE.PAYMENT_INPUT, RoutesResRoutes.PAYMENT_INPUT],
]);
